export default "__VITE_ASSET__CgwUncN$__"